import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isAssignCostProfileToResourceRequestFailure(costProfile, resource) {
      const req = getState().find(
        (req) =>
          req.costProfile.uuid === costProfile.uuid &&
          req.resource.uuid === resource.uuid,
      );

      return req ? req.request.isFailure : false;
    },
    isAssignCostProfileToResourceRequestPending(costProfile, resource) {
      const req = getState().find(
        (req) =>
          req.costProfile.uuid === costProfile.uuid &&
          req.resource.uuid === resource.uuid,
      );

      return req ? req.request.isPending : false;
    },
    isAssignCostProfileToResourceRequestSuccess(costProfile, resource) {
      const req = getState().find(
        (req) =>
          req.costProfile.uuid === costProfile.uuid &&
          req.resource.uuid === resource.uuid,
      );

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
